<ng-container *ngIf="chat?.kind === 'reply'">
  <div class="chat-reply" role="button" tabindex="0"
    [matTooltip]="'Go to message' | translate"
    (click)="goToReply.emit(chat); $event.stopPropagation()"
    (keydown.enter)="goToReply.emit(chat); $event.stopPropagation()">
    <mat-icon class="chat-reply-icon">reply</mat-icon>
    <div class="chat-reply-text">
      <span class="chat-reply-sender">{{ chat.reply?.senderName }}</span>
      <span class="chat-reply-snippet">{{ chat.reply?.snippet }}</span>
    </div>
  </div>
  <p *ngIf="chat.content" class="chat-reply-body">{{ chat.content }}</p>
</ng-container>

<div *ngIf="chat?.kind === 'location'" class="chat-location">
  <button type="button" mat-icon-button class="chat-action-icon" [matTooltip]="'Map' | translate"
    (click)="openLocation.emit(chat); $event.stopPropagation()">
    <mat-icon>place</mat-icon>
  </button>
  <span>{{ chat.content || ('Location' | translate) }}</span>
</div>

<p *ngIf="chat?.kind !== 'reply' && chat?.kind !== 'location' && chat?.content != undefined">{{ chat.content }}</p>

<img *ngIf="chat.url != undefined && chat.url != ''" [src]="chat.url"
  style="max-width: 100%;display: block; max-height: 20vh;" (load)="imageLoad.emit()"
  (click)="viewImage.emit(chat.url)" />
<a *ngIf="chat.fileurl != undefined && chat.fileurl != ''" [href]="chat.fileurl"
  style="max-width: 100%;display: block; max-height: 20vh;" target="_blank">
  <img [src]="chat.icon" [alt]="chat.fileName" width="100" (load)="imageLoad.emit()" />
</a>
